module.exports = __webpack_public_path__ + "img/nature-38.36c1b80b.jpg";